import { useUser } from '@gat-ship/user'
import type { SupportSession } from '@gat-ship/types'
import { accessCodes } from '@gat-ship/types'
import { isSupportSessionExpired } from '../model/support-session-utils'

/**
 * Visibility predicates for support-session actions: whether the current
 * user can see the grant/start/end buttons for a given session. Pure
 * checks only — opening modals is the call site's job (via
 * `useSupportModals`) and mutations live on the session services.
 */
export function useSupportSessionPermissions() {
  const user = useUser()

  function canGrantSupportAccess() {
    return user.hasPermission(accessCodes.system.support.createSupportSession)
  }

  function canEndSupportSession(supportSession: SupportSession) {
    return !isSupportSessionExpired(supportSession)
  }

  function canStartSupportSession(supportSession: SupportSession) {
    const isAssignedToSupportUser =
      supportSession.supportPersonUserId === user.id.value
    return (
      user.isSupportUser.value &&
      !user.isSupportSession.value &&
      !isSupportSessionExpired(supportSession) &&
      isAssignedToSupportUser
    )
  }

  return {
    canGrantSupportAccess,
    canEndSupportSession,
    canStartSupportSession
  }
}
